// extracted by css-extract-rspack-plugin
module.exports =  {"root":"b42fd74872","rootYear2022":"e9e9b108f9","notice":"d5c9497b80","noticePetsshop":"a846326906","pets":"ef74a960ce"};